<h2 mat-dialog-title>Modifier une grille de vente</h2>
<mat-dialog-content>
    <form [formGroup]="usageRateForm">
        <mat-form-field class="w-full">
            <mat-label>Nom</mat-label>
            <input matInput type="text" formControlName="name">
        </mat-form-field>

        <mat-form-field class="w-full">
            <mat-label>Description</mat-label>
            <textarea matInput cdkTextareaAutosize cdkAutosizeMinRows="2" cdkAutosizeMaxRows="5" formControlName="description"></textarea>
        </mat-form-field>

        @if (usageRate.is_exception) {
        <mat-form-field class="w-full">
            <mat-label>Type d'exception</mat-label>
            <mat-select formControlName="type">
                <mat-option>Non spécifié</mat-option>
                @for (exceptionType of exceptionTypes | keyvalue; track exceptionType.key) {
                <mat-option [value]="exceptionType.key">{{ exceptionType.value }}</mat-option>
                }
            </mat-select>
        </mat-form-field>
        }
    </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button matButton [mat-dialog-close]>Annuler</button>
    <button matButton (click)="submit()">Valider</button>
</mat-dialog-actions>